/**
 * Web-specific implementation of the fretboard layout hook.
 * Uses web's useFretboardConfigStore for configuration.
 */

import { createFretboardLayoutHook } from '@fretgenius/ui';
import { useFretboardConfigStore } from '../stores/useFretboardConfigStore';

/**
 * Web implementation of the fretboard layout hook.
 * Uses the web-specific fretboard config store implementation.
 */
export const useFretboardLayout = createFretboardLayoutHook(useFretboardConfigStore);
